import posthog from 'posthog-js';
import { env } from '@/lib/env';

let initialized = false;

export function initPostHog(): void {
  if (initialized) return;
  if (!env.posthogKey) return;
  posthog.init(env.posthogKey, {
    api_host: env.posthogHost ?? 'https://app.posthog.com',
    capture_pageview: false,
    capture_pageleave: true,
    person_profiles: 'identified_only',
    autocapture: false,
  });
  initialized = true;
}

export { posthog };
